import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Icon, Link } from '../components'
import { formatCartCountLabel } from './bulkOrderLabels'
import { CompactStep, StepContent, StepsContainer } from './BulkOrderSteps.styles'

const BulkOrderSteps = ({ activeStep, cartLineCount }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const steps = useMemo(
    () => [
      {
        id: 1,
        icon: 'IosBook',
        text: t('catalog'),
        to: Link.BULK_ORDER,
        enabled: true,
      },
      {
        id: 2,
        icon: 'IosCart',
        text: formatCartCountLabel(t('cart'), cartLineCount),
        to: Link.BULK_ORDER_CART,
        enabled: cartLineCount > 0 || activeStep === 2,
      },
    ],
    [t, cartLineCount, activeStep],
  )

  const handleStepClick = useCallback(
    step => {
      if (!step.enabled || step.id === activeStep) return
      navigate(step.to)
    },
    [activeStep, navigate],
  )

  return (
    <StepsContainer>
      {steps.map(step => {
        const isActive = step.id === activeStep
        const hasFilledCart = step.id === 2 && cartLineCount > 0
        const isDone = step.id < activeStep || (hasFilledCart && !isActive)
        const isDisabled = !step.enabled && !isActive

        return (
          <CompactStep
            key={step.id}
            disabled={isDisabled}
            active={isActive}
            done={isDone}
            onClick={() => handleStepClick(step)}
          >
            <StepContent>
              {step.icon && <Icon name={step.icon} size={16} withoutTooltip />}
              {step.text}
            </StepContent>
          </CompactStep>
        )
      })}
    </StepsContainer>
  )
}

BulkOrderSteps.propTypes = {
  activeStep: PropTypes.oneOf([1, 2]).isRequired,
  cartLineCount: PropTypes.number.isRequired,
}

export default BulkOrderSteps
